module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwAQMAAABtzGvEAAAABlBMVEUAAADMzMzIT8AyAAAAAXRSTlMAQObYZgAAABlJREFUGNNjoCNgbCCLYvz/vwFKkWsK/QAAjYMND9nHpnQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/shop_add_gray.png
// module id = 81
// module chunks = 40